import { render, staticRenderFns } from "./ylw.vue?vue&type=template&id=42087c54&scoped=true&"
var script = {}
import style0 from "./ylw.vue?vue&type=style&index=0&id=42087c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42087c54",
  null
  
)

export default component.exports